if (customElements.get('component-suscriber') === undefined) {
    class Suscriber extends HTMLElement {
        constructor() {
            super();
            this.user = this.getAttribute('data-user');
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.suscribe();
        }
        async suscribe() {
            if (this.user != null) {
                const urlParams = new URLSearchParams(window.location.search);
                let id = urlParams.get('preapproval_id');
                if (id != null) {
                    const url = `https://controlexpert.goldensubdev.com/suscribe.php?id=${id}&user=${this.user}`;
                    try {
                        const response = await fetch(url, {
                            method: 'GET'
                        });
                        console.log(response);
                        if (response.ok) {
                            // Si la respuesta es OK, cambiar el innerText del elemento
                            this.innerText = 'Suscripción validada';
                        }
                        else {
                            console.error('Error al validar la suscripción');
                        }
                    }
                    catch (error) {
                        console.error('Error en la petición:', error);
                    }
                }
                else {
                    console.error('No se pudo recuperar la membresia');
                }
            }
        }
    }
    customElements.define('component-suscriber', Suscriber);
}
